import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/layers/main/toolbar';
import {toggleSound} from '../../../reducers/app/actions';
import ModalsUtil from '../../../utils/modals';
import ImageUtil from '../../../utils/image';

export default () => {
    const {language, sounds} = useSelector(Selector),
          dispatch = useDispatch();


    return (
        <div className="login-toolbar animate__animated animate__fadeIn">
            <div className="buttons">
                <div className={`button sounds ${!sounds ? 'muted' : ''}`} onClick={e => dispatch(toggleSound(!sounds))}></div>
                <div className="button" onClick={e => ModalsUtil.open('language')}>
                    <ImageUtil
                        path={`/images/flags/${language}.png`}
                        alt={language} />
                </div>
            </div>
        </div>
    )
}